import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoService } from '../../seo/seo.service';

type Partner = {
  name: string;
  logo: string;
  url: string;
  description: string;
};

@Component({
  standalone: true,
  selector: 'app-collaboratori',
  imports: [CommonModule],
  templateUrl: './collaboratori.html',
  styleUrls: ['./collaboratori.scss'],
})
export class CollaboratoriComponent implements OnInit {

  partners: Partner[] = [
    {
      name: 'Di Renzo',
      logo: 'assets/partners/direnzo.webp',
      url: 'https://www.direnzoassicurazioni.it/',
      description: 'Realtà del territorio con servizi professionali e supporto consulenziale per aziende e privati.'
    },
    {
      name: 'Europont',
      logo: 'assets/partners/europont.webp',
      url: 'https://www.europont.net/',
      description: 'Servizi dedicati al settore edile, con attività operative e soluzioni su cantiere.'
    },
    {
      name: 'Eurotek',
      logo: 'assets/partners/eurotek.webp',
      url: 'https://www.eurotekpescara.it/',
      description: 'Soluzioni e supporto tecnico per aziende, con attività rivolte a contesti professionali e industriali.'
    },
    {
      name: 'Futura',
      logo: 'assets/partners/futura.webp',
      url: 'https://www.futura-dev.com/it',
      description: 'Soluzioni digitali e servizi professionali: sviluppo, innovazione e progetti su misura.'
    },
    {
      name: 'Infobasic',
      logo: 'assets/partners/infobasic.webp',
      // ⚠️ meglio senza parametri adv (gclid ecc.) per SEO
      url: 'https://www.infobasic.it/',
      description: 'Formazione in ambito digitale e percorsi professionali, con attività e progetti sul territorio.'
    },
    {
      name: 'Italia Distribuzione Import',
      logo: 'assets/partners/italia distribuzione.webp',
      url: 'https://www.italiadistribuzione.com/',
      description: 'Distribuzione e fornitura: prodotti e soluzioni per aziende e professionisti.'
    },
    {
      name: 'Emme Ci Traslochi',
      logo: 'assets/partners/mc.webp',
      url: 'https://www.emmecitraslochi.it/',
      description: 'Traslochi e movimentazione: logistica, supporto operativo e servizi per privati e aziende.'
    },
    {
      name: 'Pluralis',
      logo: 'assets/partners/pluralis.webp',
      url: 'https://www.pluraliscoworking.com/',
      description: 'Spazi e servizi di coworking: ambienti professionali e soluzioni flessibili per lavoro e meeting.'
    },

    /* ✅ NUOVI */
    {
      name: 'SportAccademy',
      logo: 'assets/partners/sportaccademy.webp',
      url: 'sportaccademy pescara', // TODO: metti il link ufficiale
      description: 'Centro sportivo e attività fitness: servizi e percorsi dedicati al benessere e alla preparazione.'
    },
    {
      name: 'Studio Ivone',
      logo: 'assets/partners/ivone.webp',
      url: 'https://www.studioivone.it/', // TODO: metti il link ufficiale
      description: 'Studio professionale sul territorio: consulenza e supporto dedicato per aziende e privati.'
    },

    {
      name: 'Centro Pollio',
      logo: 'assets/partners/pollio.webp',
      url: 'https://centropollio.it/',
      description: 'Centro specializzato con servizi dedicati e attività professionali nel settore sanitario.'
    },
    {
      name: 'Santa Lucia – Centro Analisi',
      logo: 'assets/partners/santa lucia.webp',
      url: 'https://santalucialaboratorioanalisi.it/',
      description: 'Laboratorio di analisi: servizi diagnostici e supporto per prelievi e attività cliniche.'
    },
    {
      name: 'MV TechCore',
      logo: 'assets/partners/mvtechcore.webp',
      url: 'https://mvtechcore.it/',
      description: 'Agenzia che ha realizzato il sito: sviluppo, SEO tecnico, performance e gestione evolutiva.'
    },
  ];

  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.setupSeo();
  }

  trackByPartnerName(_: number, item: Partner) {
    return item.name;
  }

  private setupSeo(): void {
    const itemList = this.partners.map((p, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: p.name,
      url: p.url
    }));

    this.seo.updateTags({
      title: 'I nostri migliori collaboratori | SAMI Pulizie',
      description:
        'Scopri i migliori collaboratori e partner di SAMI Pulizie a Pescara e provincia: loghi, descrizioni e link ai siti ufficiali.',
      keywords:
        'collaboratori SAMI Pulizie, partner SAMI Pulizie, Pescara, collaborazioni, aziende partner',
      canonicalUrl: '/collaboratori',
      ogTitle: 'I nostri migliori collaboratori | SAMI Pulizie',
      ogDescription:
        'Partner e collaborazioni di SAMI Pulizie: loghi, descrizioni e link ai siti ufficiali.',
      ogImage: '/assets/logo.png',
      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: 'I nostri migliori collaboratori',
        itemListElement: itemList
      }
    });
  }
}
